import { TablePageLayout } from '@common/components/TablePageLayout';
import { PreordersTable } from '@features/preorders/components/PreordersTable';
import { PreordersToolbar } from '@features/preorders/components/PreordersToolbar';
import { usePreordersFiltersUrl } from '@features/preorders/hooks/usePreordersFiltersUrl';

export default function PreordersPage(): React.ReactNode {
	// Sync preorder filters with URL query parameters
	usePreordersFiltersUrl();

	return (
		<TablePageLayout
			title='Preorders'
			aboveTableContent={<PreordersToolbar />}
			tableContent={<PreordersTable />}
		/>
	);
}
